import React, { Component } from 'react';
import moment from 'moment-timezone';
import { compose } from 'recompose';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { SCREEN_WIDTH } from '../../App.js';
import axios from 'axios';
import Media from "react-media";
import { STATUS } from './TicketsContainer.js';

let cancelToken;
let state;
let tokenSession;

class Ticket extends Component {

  constructor(props) {
    super(props);
    if (tokenSession !== props.getTokenSession()) {
      state = this.getInitState();
    }
    this.state = state;
  }

  getInitState = () => {
    return {
      ticket_data: {
        comments: []
      }
    };
  }

  componentWillMount() {
    cancelToken = axios.CancelToken.source();
    const ticket = JSON.parse(this.props.location.state.ticket);

    this.getTicket({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession(),
      ticket_id: ticket.id
    });
  }

  getTicket = (params) => {
    this.props.post(
      "/getTicket",
      params,
      (response) => this.didGetTicket(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  didGetTicket = (response) => {
    this.setState({ ticket_data: response });
  }

  renderCommentsTable = (comments) => {
    const { t } = this.props;

    return(
      <div>
        <h4 className="page-header text-primary"><strong>{t('dashboard.tickets.label_comments')}</strong></h4>

        <div className="table-responsive">          
          <table className="table table-bordered">
            <thead>
              <tr>
                <th><center>{t('dashboard.tickets.label_added')}</center></th>
                <th><center>{t('dashboard.tickets.label_comment')}</center></th>
                <th><center>{t('dashboard.tickets.label_date')}</center></th>
              </tr>
            </thead>
            <tbody>
              {comments.map((_, index) =>
                  <tr key={index}>
                    <td><center>{comments[index].user}</center></td>
                    <td>{comments[index].comment}</td>
                    <td><center>{moment(comments[index].created, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY')}</center></td>
                  </tr>
              )}
            </tbody>
          </table>
        </div>

      </div>
    );

  }

  renderClosingData = (ticket_data) => {
    const { t } = this.props;

    return(
      <div>
        <h4 className="page-header text-primary"><strong>{t('dashboard.tickets.label_closing_data')}</strong></h4>
        <p>
          <span className="text-primary"><strong>{t('dashboard.tickets.label_closing_date')} </strong></span>
          {ticket_data.closing_date ? moment(ticket_data.closing_date, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY') : '--'}
        </p>
        <p>
          <span className="text-primary"><strong>{t('dashboard.tickets.label_closing_comment')} </strong></span>
          {ticket_data.closing_comment ? ticket_data.closing_comment : '--'}
        </p>
      </div>
    );

  }

  render() {
    const { t } = this.props;
    const ticket = JSON.parse(this.props.location.state.ticket);
    const ticket_data = this.state.ticket_data;
    let status;
    let textStyle;

    switch (ticket.status) {
      default:
      case STATUS.OPEN:
        status = t('dashboard.tickets.status_open');
        textStyle = "label-warning";
        break;
      case STATUS.CLOSED:
        status = t('dashboard.tickets.status_closed');
        textStyle = "label-primary";
        break;
    }

    return(
      <div>
        <h2 className="page-header">Ticket {ticket.id}</h2>
        <h4>
          <span className={"label "+textStyle}>{status}</span>&emsp;
          <span className={"label label-info"}>{ticket_data.category}</span>
        </h4>
        <h4 className="page-header text-primary"><strong>{t('dashboard.tickets.label_description')}</strong></h4>
        <p>{ticket_data.report}</p>

        {ticket_data.comments.length>0 && this.renderCommentsTable(ticket_data.comments)}

        {ticket.status == STATUS.CLOSED && this.renderClosingData(ticket_data)}

      </div>
    );
  }


}

export default compose(
  translate('common'),
  withRouter
)(Ticket);



// WEBPACK FOOTER //
// ./src/dashboard/tickets/Ticket.js